(function() {
	'use strict';

	angular.module('widgets.buyer')
	.directive('myPrsToFirmChart', myPrsToFirmChart);
	
	function myPrsToFirmChart($window, $state, $rootScope, $experiments, buyerStdMyPrsToFirmService) {
		return {
			restrict: 'E',
			scope: {
				data: '=data'
			},
			link: function (scope, elem, attrs) {
				if (!scope.data) {
					return;
				}
				var data = scope.data;
				var chart = c3.generate({
					size: getSize(),
					bindto: elem[0],
					data: {
						json: [
							{ latePRCountOver14: data.latePRCountOver14 },
							{ latePRCountUnder14: data.latePRCountUnder14 },
							{ latePRCountUnder7: data.latePRCountUnder7 },
							{ toFirmPRCount: data.toFirmPRCount }
						],
						keys: { value: ['latePRCountUnder7', 'latePRCountUnder14', 'latePRCountOver14', 'toFirmPRCount'] },
						groups: [[
							'latePRCountOver14',
							'latePRCountUnder14',
							'latePRCountUnder7',
							'toFirmPRCount'
						]],
						labels: false,
						names: {
							latePRCountOver14: 'PRs Inside Lead Time',
							latePRCountUnder14: 'PRs Inside Lead Time',
							latePRCountUnder7: 'PRs Inside Lead Time',
							toFirmPRCount: 'PRs Inside Procurement Lead Time'
						},
						colors: {
							latePRCountUnder7: '#0C9D4D',
							latePRCountUnder14: '#F4CE00',
							latePRCountOver14: '#D30A0A',
							toFirmPRCount: '#005FA5'
						},
						classes: {
							latePRCountUnder7: 'late-under-7',
							latePRCountUnder14: 'late-under-14',
							latePRCountOver14: 'late-over-14',
							toFirmPRCount: 'to-firm'
						},
						type: 'bar'
					},
					tooltip: { show: true },
					axis: {
						rotated: true,
						x: {
							categories: [
								'Inside Lead Time (14+ days old)',
								'Inside Lead Time (7-14 days old)',
								'Inside Lead Time (<7 days old)',
								'Inside Procurement Lead Time'
							],
							tick: { multiline: false },
							type: 'category'
						},
						y: {
							tick: {
								values: [0, Math.max(data.latePRCountUnder7, data.latePRCountUnder14, data.latePRCountOver14, data.toFirmPRCount)]
							}
						}
					},
					padding:  getPadding(),
					legend: { hide: true }
				});

				function getPadding() {
					return {
						left: $rootScope.slideshowView ? 300 : 210,
						bottom: 10,
						top: 10,
						right: 10
					};
				}
				function getSize() {
					return {
						height: $rootScope.slideshowView ? $window.innerHeight - 300 :
							$window.innerHeight > 800 ? 250 : 160,
						width: jQuery(elem).parent().innerWidth()
					};
				}

				angular.element($window).bind('resize', _.debounce(function() { chart.resize(getSize()); }, 100));

				jQuery(elem).on('click', '.tick', function(e) {
					var target = $(e.target).closest('.tick');
					var i = jQuery(elem).find('.c3-axis .tick').index(target);
					var type = ['over14', 'under14', 'under7', 'toFirm'][i];
					pendo.track('widgetInteraction', {
						widgetType: 'buyerStdMyPrsToFirm-' + type,
						dashboardParentName: $rootScope.$$childTail.model.baseReportName,
						interaction: 'reportDrilldown'
					});

					var url = $state.href('app.supply-chain.purchase-requisitions') + buyerStdMyPrsToFirmService.getReactDrilldownFilterString(type);

					window.open(url, '_blank');
				});
			}
		};
	}
})();